// Port of api/fuel/app/classes/filter/search/games/filters/query/game/duration.php
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'game.duration',
	priority: 30,
	require: function(config, filter) {
		return rangeActive(filter.duration, 0, 360)
	},
	run: function(config, filter, data, query) {
		if (filter.durations && filter.durations.absolute) {
			query.where('g.game_time_min', '>=', filter.duration.from)
			query.where('g.game_time_max', '<=', filter.duration.to)
		} else {
			query.where('g.game_time_min', '<=', filter.duration.to)
			query.where('g.game_time_max', '>=', filter.duration.from)
		}
	}
}
